export const TestIds = {
  disclaimer: 'chat-disclaimer',
  learnMore: 'chat-disclaimer-learn-more',
};
